import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CommuneGroupItem',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  communeGroup: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {



return { __sfc: true, }
}

})